module.exports = __webpack_public_path__ + "img/1.c30c14d8.jpg";